import {request} from './request'

// 首页数据-导出
export function getCategory(){
    return request({
        // 配置参数--url
        url:'/api/goods'
    })
}

export function getCategoryGoods(order='sales',cid=0,page=1){
    return request({
        // 配置参数--url
        url:'/api/goods?category_id='+cid+'&page='+page+'&'+order+'=1',
    })
}
